<div class="dialog-header">
  <h2 mat-dialog-title class="dialog-title">Reject this company?</h2>
  <p class="dialog-subtitle">"{{ data.companyName }}"'s registration will be closed. Give a reason for the record.</p>
</div>

<mat-dialog-content class="dialog-content">
  <app-error-banner [message]="errorMessage()" />

  <mat-form-field appearance="outline">
    <mat-label>Reason</mat-label>
    <textarea matInput [(ngModel)]="reason" name="reason" rows="3" placeholder="Registration number could not be verified"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
  <button
    mat-flat-button
    class="btn-submit btn-submit--danger"
    (click)="submit()"
    [disabled]="isSubmitting() || !reason.trim()"
  >
    @if (isSubmitting()) {
      <mat-icon class="spinner">progress_activity</mat-icon>
    }
    {{ isSubmitting() ? 'Rejecting…' : 'Reject' }}
  </button>
</mat-dialog-actions>
